export default __webpack_public_path__ + "static/floor2-slide-4-8eafbba2f649b644269f37096bd5b8d5.jpg";